// NOTE all the paths MUST be relative. DO NOT START THEM WITH '/'

export const ROUTE_NAMES = {
  LIST: 'market-list',
  DETAILS: 'market-details'
}

const ROUTES = {
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'market'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: 'market/:id'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LIST].name,
    path: ROUTES[ROUTE_NAMES.LIST].path,
    component: (resolve) => require(['./views/list'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.DETAILS].name,
    path: ROUTES[ROUTE_NAMES.DETAILS].path,
    component: (resolve) => require(['./views/details'], resolve)
  }
]
